import "./EditedFeaturePanel.css";
import Collapsible from "../../genericComponents/Collapsible/Collapsible";
import { NauticalObjectValidationResult } from "../../../types/types";

interface ValidationResultProps {
    validationResult?: NauticalObjectValidationResult;
}

const ValidationResult = (props: ValidationResultProps) => {
    const renderValidationResultHeader = () => {
        return props.validationResult?.isValid ? (
            <span className="validation-success">Godkjent</span>
        ) : (
            <span className="validation-fail">Underkjent</span>
        );
    };

    return (
        <>
            <div className="flex-row w-100 space-between">
                <span className="job-card-key">Validering status</span>
                <span className="job-card-value bold">
                    {props.validationResult === undefined ? (
                        <span className="validation-inprogress">Validerer...</span>
                    ) : (
                        renderValidationResultHeader()
                    )}
                </span>
            </div>

            {props.validationResult && !props.validationResult.isValid && (
                <Collapsible
                    isOpen={false}
                    setIsOpen={() => {}}
                    title="Vis valideringsfeil"
                    className="edited-feature-panel-collapsible"
                >
                    {props.validationResult.errors
                        .filter((error) => !error.relatedFeatureClassName)
                        .map((error, index) => (
                            <div
                                key={`validationerror${error.attributeName}${index}`}
                                className="validation-error-item"
                            >
                                <span className="validation-error-attribute">{error.attributeName}</span>
                                <span className="validation-error-message">{error.errorMessage}</span>
                            </div>
                        ))}
                    {Object.entries(
                        props.validationResult.errors
                            .filter((error) => error.relatedFeatureClassName)
                            .reduce(
                                (acc, error) => {
                                    const className = error.relatedFeatureClassName!;
                                    if (!acc[className]) {
                                        acc[className] = [];
                                    }
                                    acc[className].push(error);
                                    return acc;
                                },
                                {} as Record<string, typeof props.validationResult.errors>
                            )
                    ).map(([className, errors]) => (
                        <div key={`validationgroup${className}`} className="validation-group">
                            <div className="validation-class-name">{className}</div>
                            <div className="validation-class-errors">
                                {errors.map((error, index) => (
                                    <div
                                        key={`validationerror${error.attributeName}${index}`}
                                        className="validation-error-item"
                                    >
                                        <span className="validation-error-attribute">{error.attributeName}</span>
                                        <span className="validation-error-message">{error.errorMessage}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    ))}
                </Collapsible>
            )}
        </>
    );
};

export default ValidationResult;
